import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import { changeField, deleteField } from 'bundles/apex/playbooks/config/store/playbooks/actions';

import ManagedInput from 'components/form/managed_input';
import PropertyTypes from './property_types';

export function PlaybookField({ changeField, deleteField, field, playbook }) {
  return (
    <tr>
      <td className="name">{field.label}</td>

      <td>
        <ManagedInput
          name="required"
          type="select"
          value={(field.required || false).toString()}
          onValueChange={required => changeField(playbook, field, { required: required === 'true' })}
        >
          <option value="true">Required</option>
          <option value="false">Optional</option>
        </ManagedInput>
      </td>

      <PropertyTypes
        propertyTypeIds={field.propertyTypeIds}
        onPropertyTypeIdsChange={propertyTypeIds => changeField(playbook, field, { propertyTypeIds })}
      />

      <td width="0">
        <FontAwesomeIcon
          className="clickable"
          icon={faTrashAlt}
          onClick={() => deleteField(playbook, field)}
        />
      </td>
    </tr>
  );
}

PlaybookField.propTypes = {
  changeField: PropTypes.func.isRequired,
  deleteField: PropTypes.func.isRequired,
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    propertyTypeIds: PropTypes.arrayOf(PropTypes.number),
    required: PropTypes.bool,
    stage: PropTypes.string.isRequired,
  }).isRequired,
  playbook: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  changeField,
  deleteField,
};

export default connect(null, mapDispatchToProps)(PlaybookField);
